"use client";

import { m, useInView } from "framer-motion";
import React, { useRef } from "react";
import { variantsBlock } from "../variants";

interface Props {
  data?: any;
}

export default function ResultsSection({ data }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
  });

  return (
    <m.section
      className={`container mx-auto flex flex-col items-center gap-16 section ${data?.darkerBackground ? "bg-neutral-200/50" : ""}`}
      ref={ref}
      transition={{ staggerChildren: 0.05, delayChildren: 0.2 }}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
    >
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12">
        <div className="w-full flex flex-col sm:col-span-2 lg:col-span-1">
          {data?.title && <h2 className="mono bullet text-left">{data.title}</h2>}
        </div>
        {data?.items?.map((item: any, index: number) => (
          <React.Fragment key={index}>
            <div className={`flex flex-col gap-4 w-full `}>
              <m.div
                className="w-full h-4 bg-primary"
                initial={{ width: "0%" }}
                animate={{ width: isInView ? "100%" : "0%" }}
                transition={{
                  duration: 1,
                  delay: 0.1 * index + 0.2,
                  ease: [0.83, 0, 0.17, 1],
                }}
              />
              <m.div
                variants={variantsBlock}
                className="flex flex-col gap-4 w-full"
              >
                <span className="mono">
                  {(index + 1).toLocaleString("en-US", {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                  })}
                </span>
                <h3 className="h4 uppercase">{item.title}</h3>
                <div className="text-lg leading-snug">{item.text}</div>
              </m.div>
            </div>
            {(index % 4 === 2 || index % 4 === 0) && (
              <div className="w-full hidden lg:block" />
            )}
          </React.Fragment>
        ))}
      </div>
    </m.section>
  );
}
